<template>
  <b-overlay :show="uploading" rounded="sm">
    <div>
      <b-card body-class="px-0" class="border-0" :style="customColor">
        <div class="d-flex title-bar-block">
          <div class="icon-block me-4">
            <button @click="cancel()" id="cancle-label-button">
              <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
            </button>
          </div>
          <div class="text">
            <span class="me-2">
              {{ $translate("update_service_request") }}</span>
          </div>
        </div>
        <b-card-body class="p-0">
          <b-row v-if="!editMode">
            <b-col cols="12" md="6">
              <h5>
                {{ $translate("reference_no") }}
                {{ model.reference_no }}
              </h5>
            </b-col>
            <b-col cols="12" md="6" v-if="model.completed == 1">
              <h5>
                {{ $translate("completion_date") }}:
                {{ model.completed_at | formatDateTime }}
              </h5>
            </b-col>
          </b-row>
          <b-form @submit.stop.prevent="createOrder" ref="customerForm" class="filter-form mt-2">
            <b-row class="mt-0 mt-md-3">
              <b-col cols="12" md="6" class="dd">
                <label for="input-type" class="mb-3"
                  ><strong
                    >{{ $translate("type") }}<span class="red">*</span></strong
                  ></label
                >
                <b-form-select
                  id="input-type-order"
                  class="form-control"
                  required
                  v-model="model.order_type_id"
                  disabled
                  :options="orderTypes | mapOptions"
                  v-custom-validation="$selectRequired()"
                  @change="onOrderTypeChange"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled>{{
    $translate("select_activity_type")
  }}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="12" md="6" class="dd">
                <label class="mb-3 mt-3 mt-md-0" for="input-category"><strong>{{ $translate("category")
                    }}</strong></label>
                <b-form-select id="input-category" class="form-control" v-model="model.request_category_id"
                  :disabled="!editMode" :options="categories | mapOptions" v-custom-validation="$selectRequired()">
                  <template #first>
                    <b-form-select-option :value="null">{{
    $translate("select_category_placeholder")
  }}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6" class="mt-3">
                <label class="mb-3" for="input-description"><strong>{{ $translate("description") }}</strong></label>
                <b-form-textarea id="input-description" v-model="model.description" :disabled="!editMode"
                  :placeholder="$translate('activity_description_placeholder')" rows="5"></b-form-textarea>
              </b-col>
              <b-col cols="12" md="6" class="mt-3">
                <label class="mb-3" for="input-date"><strong>{{ $translate("service_location") }}</strong></label>
                <location-section ref="locationSection" :sectionOnly="true" v-model="model.delivery_location_section_id"
                  @set-location-section="(evt) => { setLocationData(evt, 'model') }" :hide-controls="true" title=""
                  :modal-title="$translate('service_location')" :is-modal="true" :customer_id="customer?.id ?? -1">
                  <template #default="{ setSearchMode, hideModal }">


                    <b-card-footer>
                      <div class="d-flex gap-2 mb-3 mt-3 justify-content-center">


                        <b-button @click="setSearchMode()" id="locations-button" variant="info" :disabled="!editMode">{{
    $translate("locations")
  }}</b-button>
                        <b-button class="mr-2" id="submit-button" variant="info" @click="hideModal()">{{ $translate("submit") }}</b-button>

                      </div>
                    </b-card-footer>



                  </template>
                </location-section>
                <!-- <b-form-input id="input-date" v-model="model.date" type="date" :disabled="!editMode"
                                    required></b-form-input> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6" class="mt-3">
                <label class="mb-3" for="input-date"><strong>{{ $translate("requested_due_date")
                    }}<span class="red">*</span></strong></label>
                <b-form-input id="input-date" v-model="model.date" required type="date" :disabled="!editMode"
                  v-custom-validation="$textRequired()"></b-form-input>
              </b-col>
              <b-col cols="12" md="6" class="mt-3">
                <label class="mb-3" for="input-time"><strong>{{ $translate("requested_due_time")
                    }}<span class="red">*</span></strong></label>
                <b-form-input id="input-time" :disabled="!editMode" required v-model="model.time" type="time"
                  v-custom-validation="$textRequired()"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" v-if="!editMode" class="mt-3">
                <label class="mb-3" for="input-driver"><strong>{{ $translate("assigned_to") }}</strong></label>
                <b-form-input id="input-driver" :value="officer_name" readonly></b-form-input>
              </b-col>
              <b-col cols="12" v-if="!editMode" class="mt-3">
                <label class="mb-3" for="input-driver"
                  ><strong>{{ $translate("total") }}</strong></label
                >
                <b-form-input
                  id="input-driver"
                  :value="total_amount"
                  disabled
                ></b-form-input>
              </b-col>
              <b-col cols="12" v-if="!editMode" class="mt-3">
                <label class="mb-3" for="input-driver"
                  ><strong>{{ $translate("total") }}</strong></label
                >
                <b-form-input
                  id="input-driver"
                  :value="total_amount"
                  disabled
                ></b-form-input>
              </b-col>
              <input type="hidden" v-model="model.is_draft">
              <input type="hidden" v-model="model.note_id">
              <b-col cols="12" class="mt-3">
                <label class="mb-3" for="input-group-note"><strong>{{ $translate("comments") }}</strong></label>
                <b-form-textarea id="input-note" :disabled="!editMode" v-model="model.note"
                  :placeholder="$translate('enter_comments')" rows="3" max-rows="6"></b-form-textarea>
              </b-col>
            </b-row>
            <MasterDocument  :activity-type-id="model.order_type_id" v-if="showDocSection"  />
            <hr>
           
            <manage-order-items  :order="order"  v-if="isDataReady" 
          />
            <b-row class="mt-3">
              <label class="mb-3" for="input-group-Attachments"><strong>{{ $translate("attachments") }}</strong></label>
              <ManageAttachments :attachments="attachments" @update-attachments="updateAttachments" />
            </b-row>
            <b-col cols="12" class="d-flex justify-content-center my-4" v-if="editMode">
              <b-button variant="info" id="upload-attachment-btn" size="fw" class="me-2" @click="showModal = !showModal">
                {{ $translate("upload_attachment") }}
              </b-button>
              <b-button type="info" @click.stop.prevent="createDraftOrder" id="submit-form-btn" class="me-2" size="fw" variant="info" :disabled="submitting ? true : false">{{
                submitting ? $translate("saving") : $translate("save")
              }}</b-button>
              <b-button type="info" id="submit-form-btn" class="me-2" size="fw" variant="info" :disabled="submitting ? true : false">{{
    submitting ? $translate("submitting") : $translate("submit")
  }}</b-button>
              <b-button id="delete-btn"  @click="delete_order()" class="me-2"
              variant="delete-button" size="fw">
              {{ $deleteLabel() }}
            </b-button>
              <b-button type="info" id="cancel-form-btn" class="ml-2" size="fw" @click="cancel()" variant="info">{{ $cancelLabel()
                }}</b-button>
            </b-col>
          </b-form>
          <b-modal v-model="showModal" id="add-attachments-modal" centered header-class="p-0"
            footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" hide-footer>
            <template #modal-title="{ cancel }">
              <div class="text-center">
                <div class="title-block text-center p-2">
                  {{ $translate("files_upload") }}
                </div>
                <div class="close-btn" @click="cancel()">×</div>
              </div>
            </template>
            <b-overlay :show="uploading" rounded="sm">
              <b-row>
                <b-col sm="12" xl="12" v-if="this.filelist.length" v-cloak>
                  <!--show a list of the selected files, with an input to (optionally) rename the file before upload-->
                  <b-list-group>
                    <b-list-group-item class="d-inline-flex p-2" v-for="(file, i) in filelist" :key="i">
                      <!--file name input to rename the file before upload-->
                      <b-form-input :placeholder="$translate('file_name')" id="add-file-name" v-model="filelist[i].fileName" required
                        v-custom-validation="$textRequired()" @change="renameFile(i, filelist[i].fileName)"  ref="inputField"  @click="selectText(i)" />

                      <!--file extension-->
                      <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{ filelist[i].extension
                        }}</span>
                        <b-form-input id="rename-file-input-small" :placeholder="$translate('description')" v-model="filelist[i].description"
                        />

                      <!--remove file from list (and from upload)-->
                      <b-button variant="outline-danger" class="test-delete-btn" :id="'delete-file-btn'+i" size="sm" @click="remove(filelist.indexOf(file))">
                        <b-icon-trash></b-icon-trash>
                      </b-button>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>

                <!--this column contains the file drop area-->
                <!--its width is automatically set based on existance of the file list column and breakpoint-->
                <b-col class="file-drop-column my-4 my-xl-0 p-0">
                  <div class="file-drop-area bg-light" @dragover="dragover" @drop="drop">
                    <!--we need an actual file input in order to have the drag&drop functionality-->
                    <!--and the File object(s) containing the files dropped-->
                    <!--We keep it invisible because we want to display something different than a file input-->
                    <input type="file" name="file-input" id="file-input" class="file-input invisible"
                      @change="onChange" />

                    <!--clicking on this label will trigger the clicked event on the file input-->
                    <!--this will cause the 'choose file' system dialog-->
                    <label for="file-input" class="w-100 text-center cursor-pointer text-muted m-0 px-3 py-5">
                      <p>
                        <b-icon-cloud-upload-fill font-scale="3"></b-icon-cloud-upload-fill>
                      </p>
                      <div>
                        <p class="mb-0">
                          {{ $translate("upload_file_note") }}
                        </p>
                        <p class="mb-0">
                          <span class="text-info">{{
    $translate("select_from_computer")
                            }}</span>
                        </p>
                      </div>
                    </label>
                  </div>
                </b-col>
              </b-row>

              <div class="text-center mt-4">
                <b-button variant="info" id="cancel-label-btn" size="fw" @click="$bvModal.hide('add-attachments-modal')" class="me-2">
                  {{ $cancelLabel() }}
                </b-button>
                <b-button type="submit" id="upload-file-btn" size="fw" :disabled="!filelist.length" variant="info" @click="onSubmit()">
                  {{ $translate("upload_files") }}
                </b-button>
              </div>
            </b-overlay>
          </b-modal>
        </b-card-body>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
// const _ = require('lodash')
import moment from "moment";
import dateTimeMixins from "@/mixins/dateTimeMixins";
import popupMixins from "@/mixins/popupMixins";
import LocationSection from "@/views/Location/LocationSection";
import ManageAttachments from "./ManageAttachments.vue";
import locationMixins from "@/mixins/locationMixins";
import ManageOrderItems from "./ManageOrderItems.vue";
import EventBus from "@/exports/event-bus.js";
import MasterDocument from './MasterDocument.vue';
export default {
  name: "create-order-form",
  components: { LocationSection, ManageAttachments ,ManageOrderItems,MasterDocument},
  mixins: [popupMixins, dateTimeMixins, locationMixins],
  props: ["item"],
  data: () => {
    return {
      isModalVisible: false,
      editMode: true,
      uploading: false,
      model: {
        order_type_id: null,
        request_category_id: null,
        description: null,
        driver_id: null,
        signature: false,
        delivery_location_section_id: null,
        attachments: [],
        note: null,
      },
      order_data : {},
      filelist: [],
      // attachment: null,
      // Controls Filepicker modal
      showModal: false,
      hasErrors: false,
      showDocSection : false,
      isDataReady : false,
    };
  },
  filters: {
    mapOptions(arr, isUser) {
      return arr.map((x) => ({
        value: x.id,
        text: isUser
          ? `${x.first_name} ${x.last_name}`
          : x.customer_portal_name || x.name,
      }));
    },
    formatDateTime(value) {
      const format1 = "YYYY-MM-DD hh:mm:A";
      var date1 = new Date(value);
      return moment(date1).format(format1);
    },
  },
  created() {
    // const { date, time } = this.getLocalPartsFrLaravelDt()
    // this.model.date = date
    // this.model.time = time
    this.$store.dispatch("orderType/customerFetchAll");
    this.$store.dispatch("requestCategory/fetchAll");
    this.$store.dispatch("users/fetchAll");
    setTimeout(() => {
      this.$store.dispatch("js_report/fetchCredentials");
    }, 500);
  },
 async  mounted() {
  this.uploading = true;
    await this.$store.dispatch('customerPortal/fetchOrder', this.$route.params.id)
    this.$store.dispatch("orders/fetchOrderItems", this.$route.params.id);
    this.setDateTime();
    this.$store.dispatch("company/fetch");
   
    console.log("this.item", this.item);
    this.order_data = this.$store.state.customerPortal.selectedOrder || {}
            
    if (this.order_data && this.order_data.id) {
      // console.log('location section ----',this.order_data);
      this.model = { ...this.order_data };
      this.model.delivery_location_section_id =
      this.customer && this.order_data.delivery_location_section_id
      ;
      
      const { attachments } = this.order_data
     this.model.note = this.order_data?.notes?.[0]?.content;
     this.model.note_id = this.order_data?.notes?.[0]?.id;
      this.storeAttachments(attachments)
      if (this.order_data.schedule_at) {
        const scheduleAt = new Date(this.order_data.schedule_at);
        this.model.date = scheduleAt.toISOString().split('T')[0]; // Extract date in 'YYYY-MM-DD' format
        this.model.time = scheduleAt.toTimeString().split(' ')[0]; // Extract time in 'HH:MM:SS' format
      }
      this.model.is_draft = 0;
      this.editMode = true;
    }
    this.uploading = false;
    this.isDataReady = true;
    document.addEventListener('paste', this.handlePaste);
  },

  computed: {
    mediaBaseUrl() {
      return this.$store.getters["mediaBaseUrl"];
    }, /////////
    componentName() {
      return this.$translate("service_request");
    },
    customColor() {
      const data = this.$store.state.company.settings || {};
      const colors = {
        "background-color": data.background_color + "!important",
        color: data.text_color + "!important",
      };
      return colors;
    },
    createCustomer() {
      return this.$route.name == "CustomerPortalNewService";
    },
    submitting() {
      return this.$store.state.customerPortal.loading;
    },
    customer() {
      return this.$store.state.customerPortal.customer;
    },
    orderTypes() {
      let orderTypes = this.$store.state.orderType.items;
      console.log("orderTypesorderTypes", orderTypes);

      orderTypes = orderTypes
        .filter((x) => {
          if (this.model.id) {
            return !!x.is_customer_portal_visible;
          } else {
            return !!x.is_customer_portal_selection;
          }
        })
        .map((x) => ({
          id: x.id,
          name: x.customer_portal_name || x.name,
          officer_id: x.officer_id,
          activity_template_id: x.activity_template_id,
          interaction_type_id: x.interaction_type_id,
        }));
      return orderTypes;
    },
    categories() {
      const categories = this.$store.state.requestCategory.categories;
      console.log("categories", categories);
      return categories;
    },
    officers() {
      const _officers = this.$store.getters["users/sorted_officers"];
      console.log("_officers", _officers);
      return _officers;
    },
    orderTypeId() {
      return this.$store.getters["customerPortal/getOrderTypeId"];
    },

    officer_name() {
      const officer = this.officers.find((x) => x.id === this.model.driver_id);
      return (officer && officer.name) || "";
    },
    attachments() {
      return this.$store.state.customerPortal.attachments;
    },
    selectedTemplate() {
      return this.$store.state.orderTemplate.selectedTemplate;
    },
    total_amount(){
      
      const orderItems = this.model.items
      let orderPrice = 0
      

      for (let item of orderItems) {
          const basePrice = parseFloat(item.price) * item.quantity
          const tax = (basePrice * parseFloat(item.tax_rate)) / 100
          orderPrice += basePrice + tax
      }
       orderPrice = (orderPrice / 1).toFixed(2).replace(",", ".");
      return orderPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    

 
    },
    order() {
            const computedOrder =
                this.$store.state.customerPortal.selectedOrder || {}
            return computedOrder
        },
    storedItems() {
      return this.$store.state.orderItemStore.items;
    },
  },
  watch: {
    "model.order_type_id": {
      handler: async function (val) {
        const orderType = this.orderTypes.find((x) => x.id == val);
        if (orderType) {
          const officer_id = orderType.officer_id;
          const activity_template_id = orderType.activity_template_id;
          const interaction_type_id = orderType.interaction_type_id;
          this.$set(this.model, "driver_id", officer_id);
          this.$set(this.model, "interaction_type_id", interaction_type_id);
          if (activity_template_id) {
            await this.$store.dispatch(
              "orderTemplate/fetchById",
              activity_template_id
            );
            this.$nextTick(() => {
            
            //  this.importItems();
              this.onOrderTypeChange(orderType.id);
            });
          
          }
        }
      },
    },
    storedItems: {
      handler: function (items) {
        console.log("stored items", items);
      },
      deep: true,
    },
    orderTypeId: {
      immediate: true,
      handler: function (val) {
        console.log("valll", val);
        this.updateModel(val);
      },
      deep: true,
    },
    "item.attachments": {
      immediate: true,
      handler: function (items) {
        this.storeAttachments(items);
      },
      deep: true,
    },

    item: {
      immediate: true,
      handler(val) {
        const { date, time } = this.getLocalPartsFrLaravelDt(
          val && val.schedule_at
        );
        if (val && val.id) {
          this.model = { ...val };
          this.$set(this.model, "date", date);
          this.$set(this.model, "time", time);
          this.editMode = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    setDateTime() {
      const scheduledDate = moment().format("YYYY-MM-DD");
      const scheduledTime = moment().format("HH:mm");
      this.$set(this.model, "date", scheduledDate);
      this.$set(this.model, "time", scheduledTime);
    },
    async cancel() {
      await this.$store.dispatch('orderItemStore/clearAll');
      this.$router.push("/customer-portal/service-requests");
    },
    updateModel(orderTypeid) {
      this.$set(this.model, "order_type_id", orderTypeid || null);
    },
    onSubmit() {
      event.preventDefault();
      console.log(this.filelist);
      this.uploadFile();
    },
    async importItems() {
      try {
        let template_primary_items = [];
        if (this.selectedTemplate && this.selectedTemplate.items) {
          for (const item of this.selectedTemplate &&
            this.selectedTemplate.items) {
            const {
              master_item,
              default_quantity: quantity,
              is_secondary_order_type,
            } = item;
            if (!is_secondary_order_type) {
              template_primary_items.push({
                ...master_item,
                quantity,
                is_template_item: true,
              });
            }
          }
          const fixItem = (item) => {
            item.assets = this.linked_assets;
            item.master_item_id = item.id;
            item.price = item.selling_price;
            item.tax_rate = item.type.tax_rate;
            item.section_from_id = null;
            item.section_to_id = null;
            item.id = null;
          };
          for (const item of template_primary_items) {
            fixItem(item);
          }
          this.$set(this.model, "items", template_primary_items);
        }
      } catch (error) {
        console.error(error);
      }
    },

    updateAttachments(evt) {
      this.model.attachments.splice(0);
      for (let attachment of evt) {
        this.model.attachments.push(attachment);
      }

      this.genericToast(
        `${this.componentName} ${this.$translate("attachments")}`,
        this.$translate("updated"),
        "success",
        this.$translate(`attachment_successfully`)
      );
    },
    createDraftOrder(){
      this.model.is_draft = 1;
      this.createOrder();
    },
    async createOrder() {
      try {
        this.uploading = true;
        const {
          storedItems: items,
         
        } = this;

        console.log('items---',items);
        const model = { ...this.model,items };
        // console.log("modelll", model)

        if (!model.order_type_id)
          throw new Error(this.$translate("activity_type_selected"));

        this.checkLocationError(model, model.delivery_location_section_id);

        model.attachments = this.attachments;

        model.schedule_at = this.getLaravelFrLocalParts(model.date, model.time);


        console.log("model", model);
        const valid = await this.$validator.validate();
        if (!valid) {
          throw new Error(this.$translate("invalid_entry"));
        }
        const data = await this.$store.dispatch(
          "customerPortal/editOrder",
          model
        );
        this.genericToast(
          this.componentName,
          this.$translate("updated"),
          "success",
          `${this.componentName} ${this.$translate("update_alert")}`
        );
        setTimeout(() => {
          this.$refs.customerForm.reset();
          this.$router.push("/customer-portal/service-requests");
        }, 1300);
        console.log(data);
        this.uploading = false;
      } catch (err) {
        console.log(err);
        this.uploading = true;
        this.doToast(this.$translate("error"), err.message, "danger");
      }
    },

    renameFile(fileIndex, newName) {
      const file = this.filelist[fileIndex].file;
      var newFile = new File(
        [file],
        `${newName}.${this.filelist[fileIndex].extension}`,
        {
          type: file.type,
        }
      );

      // Rebuild File Obj for file list array
      const fileName = newFile.name.replace(/\.[^/.]+$/, ""); //extract filename (no extension) from the file full name
      const extension = newFile.name.split(".").pop(); //extract

      this.filelist[fileIndex] = {
        fileName: fileName,
        extension: extension,
        file: newFile,
      };
    },
    onChange(event) {
      let allowedTypes = this.$allowedTypes;
      let uploadedFileName = event.target.files[0].name;
      let fileExtension = uploadedFileName.split(".").pop();
      let maxFileSize = this.$maxFileSize;
      console.log("event.target.files", event.target.files);
      if (!allowedTypes.includes(fileExtension.toLowerCase())) {
        this.doToast(
          this.$translate("error"),
          this.$translate(`invalid_file_type`),
          "danger"
        );
        return false;
      }
      if (maxFileSize < event.target.files[0].size) {
        this.doToast(
          this.$translate("error"),
          this.$translate("file_size_alert"),
          "danger"
        );
        return false;
      }
      const fileArray = [...event.target.files]; //put the files in a temporary array
      fileArray.forEach((file) => {
        const fileName = file.name.replace(/\.[^/.]+$/, ""); //extract filename (no extension) from the file full name
        const extension = file.name.split(".").pop(); //extract extensionfrom the file fullname
        this.filelist.push({
          fileName: fileName,
          extension: extension,
          file: file,
        }); //store selected files and additional data in our array
      });
    },
    onChangeDrop(event) {
      let allowedTypes = this.$allowedTypes;
      let uploadedFileName = event.dataTransfer.files[0].name;
      let fileExtension = uploadedFileName.split(".").pop();
      let maxFileSize = this.$maxFileSize;
    
      if (!allowedTypes.includes(fileExtension.toLowerCase())) {
        this.doToast(
          this.$translate("error"),
          this.$translate(`invalid_file_type`),
          "danger"
        );
        return false;
      }
      if (maxFileSize <event.dataTransfer.files[0].size) {
        this.doToast(
          this.$translate("error"),
          this.$translate("file_size_alert"),
          "danger"
        );
        return false;
      }
      const fileArray = [...event.dataTransfer.files]; //put the files in a temporary array
      fileArray.forEach((file) => {
        const fileName = file.name.replace(/\.[^/.]+$/, ""); //extract filename (no extension) from the file full name
        const extension = file.name.split(".").pop(); //extract extensionfrom the file fullname
        this.filelist.push({
          fileName: fileName,
          extension: extension,
          file: file,
        }); //store selected files and additional data in our array
      });
    },
    onPaste(event) {
            console.log('on pastes is called');
            const clipboardData = event.clipboardData || window.clipboardData;
            if (clipboardData) {
            const items = clipboardData.items;
            const fileList = [];
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.kind === 'file') {
                const file = item.getAsFile();
                fileList.push(file);
                }
            }
            this.handleFiles(fileList);
            }
        },
        handlePaste(event) {
           
            const modalElement = document.getElementById('add-attachments-modal');
           
            
            if (modalElement) {
                this.onPaste(event);
            } else {
                console.log('Else is called');
            }
        },

        handleFiles(fileList) {
            // Common functionality
            let allowedTypes = this.$allowedTypes;
            let maxFileSize = this.$maxFileSize;
            
            fileList.forEach(file => {
            const uploadedFileName = file.name;
            const fileExtension = uploadedFileName.split('.').pop();
            
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger');
                return false;
            }
            
            if (maxFileSize < file.size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger');
                return false;
            }
            
            const fileName = uploadedFileName.replace(/\.[^/.]+$/, '');
            const extension = uploadedFileName.split('.').pop();
            this.filelist.push({
                fileName: fileName,
                extension: extension,
                file: file,
            });
            });

       },
   
    remove(i) {
      this.filelist.splice(i, 1);
    },
    removeAll(i) {
      this.filelist.splice(i, i.length);
    },
    dragover(event) {
      event.preventDefault();
    },
    drop(event) {
      event.preventDefault();
      this.onChangeDrop(event);
    },
    storeAttachments(attachments) {
      this.$store.dispatch("customerPortal/load", attachments || []);
    },
    async uploadFile() {
      // console.log('upload event', event)
      /*  let files = []

            for (const file of this.filelist) {
                files.push(file.file)
            } */

      try {
        this.uploading = true;
        const files = this.filelist.map((file) => file.file);
        const p = await this.getCurrentLocation();
        console.log("coordinates", p);
        const lat = p.coords.latitude;
        const long = p.coords.longitude;

        const { keys } = await this.$store.dispatch("s3files/s3upload", files);
        let url = [];
        keys.forEach((key) => {
          url.push(`${this.mediaBaseUrl}/${key}`);
        });
        const newFiles = [];
        files.forEach((element, i) => {
          newFiles.push({
            name: element.name.replace(/\.[^/.]+$/, ""),
            url: url[i],
            file_extension: element.name.split(".").pop(),
            lat: lat,
            long: long,
          });
        });
        this.$store.dispatch("customerPortal/merge", {
          newFiles,
        });
        this.genericToast(
          this.componentName,
          this.$translate("uploaded"),
          "success",
          this.$translate(`attachment_uploaded`)
        );
        this.uploading = false;
        // Hide modal after success
        this.showModal = false;
        this.removeAll(this.filelist);
      } catch (error) {
        console.error("addAttachement", error);
        this.doToast(
          this.$translate("error"),
          this.$translate("error_adding_attachment"),
          "danger"
        );
        this.uploading = false;
      }
    },
    updateLocationSection(locationData) {
      locationData = locationData || {};
      for (const key in locationData) {
        this.$set(this.model, key, locationData[key]);
      }
    },

   async onOrderTypeChange(newOrderTypeId) {
        console.log('ordertypes----',newOrderTypeId);
        
        // Validate newOrderTypeId to ensure it is not null or undefined
        if (newOrderTypeId === null || newOrderTypeId === undefined) {
            // Clear the description if no order type is selected
            this.model.description = '';
            return;
        }

        // Find the selected order type in the store
        const selectedOrderType = this.$store.state.orderType.items.find(orderType => orderType.id === newOrderTypeId);

        console.log(selectedOrderType, 'Selected Order Type');

        // If selected order type exists, update the model's description
        if (selectedOrderType) {
            this.model.description = selectedOrderType.description;
        } else {
            // Clear the description if no matching order type is found
            this.model.description = '';
        }
        if(newOrderTypeId != null){
        
          this.uploading = true;
       
          await this.$store.dispatch('acitivityTypeDocStore/fetchdocumentsAllCustomer', {  activityTypeId : newOrderTypeId});
          if (this.$store.state.acitivityTypeDocStore.docs && this.$store.state.acitivityTypeDocStore.docs.length > 0) {
              let modelData = this.$store.state.acitivityTypeDocStore.docs;
              this.showDocSection = true;
              this.orderModel = { ...this.orderModel, document: modelData };
          } else {
            
              this.showDocSection = false;
          }

           this.uploading = false;
        }
    },
    selectText(i) {
        // Use $refs to access the input element and call select() on it
        this.$refs.inputField[i].select();
    },

    async delete_order() {
            const type =  this.componentName;
            const title = `${this.$translate('delete')} ${type}?`
            const message = `${this.$translate('delete_note')} ${this.model.name ? this.model.name :  this.componentName}?`

            // Show confirmation message
            this.confirmMessage(title, message).then(result => {
                console.log('result', result);
                if (result) {
                    // User confirmed, proceed with deletion
                    this.uploading = true;

                    this.$store
                        .dispatch('customerPortal/delete', this.model.id)
                        .then(() => {
                          this.$router.push("/customer-portal/service-requests");
                            this.$nextTick(() => {
                                this.genericToast(
                                    this.componentName,
                                    this.$translate('deleted'),
                                    'success',
                                    `${this.componentName} ${this.$translate('delete_alert')}`
                                );
                            });
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            );
                            console.error(error);
                        })
                        .finally(() => {
                          this.uploading = false;
                        });
                }
            });
        },

  },
};
</script>
